export enum EColumn {
  EXPORT = 'export',
  COMMENTS = 'comments',
  ACTIVITIES = 'activities',
  TAGS = 'tags',
  CUSTOM_FIELD = 'custom-field',
  FLAGS = 'flags',
  RELATED_POINTS = 'related-points',
}

export const USER_MANAGEMENT_CUSTOMIZED_SHARE_MARK = '*';
